import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";

// Halaman tujuan redirect Midtrans (Finish / Error Redirect URL di dashboard Midtrans).
// Midtrans menambahkan ?order_id=&status_code=&transaction_status=. Status resmi pesanan
// tetap ditentukan oleh notifikasi server-ke-server, bukan oleh halaman ini.
export default function PaymentResult({ failed = false }) {
  const { user } = useAuth();
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  const status = params.get("transaction_status");
  const pending = !failed && status === "pending";
  const ok = !failed && !pending && ["settlement", "capture"].includes(status || "settlement");

  const view = failed || (!ok && !pending)
    ? { icon: XCircle, color: "text-terracotta", title: "Pembayaran gagal", text: "Pembayaran tidak berhasil atau dibatalkan. Anda dapat mencoba membayar lagi dari halaman Pesanan Saya." }
    : pending
      ? { icon: Clock, color: "text-amber-700", title: "Menunggu pembayaran", text: "Selesaikan pembayaran sesuai instruksi (mis. Virtual Account). Status pesanan berubah otomatis setelah pembayaran diterima." }
      : { icon: CheckCircle2, color: "text-forest", title: "Pembayaran berhasil", text: "Terima kasih! Pesanan Anda akan segera diproses oleh penjual." };

  return (
    <div className="mx-auto max-w-xl px-5 lg:px-10 py-16 lg:py-24 text-center">
      <view.icon size={56} className={`mx-auto ${view.color}`} />
      <h1 className="font-display text-3xl font-bold text-ink mt-5">{view.title}</h1>
      {orderId && <p className="text-sm text-ink/55 mt-2">No. pesanan <span className="font-mono font-semibold text-ink">{orderId}</span></p>}
      <p className="text-ink/75 mt-4 text-sm">{view.text}</p>
      <div className="flex gap-3 justify-center mt-8">
        <Link to="/anggota/pesanan"><Button className="rounded-full bg-forest text-white">Lihat Pesanan Saya</Button></Link>
        <Link to={user ? "/anggota/toko" : "/toko"}><Button variant="outline" className="rounded-full">Kembali ke Toko</Button></Link>
      </div>
    </div>
  );
}
